// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3QrIj","productName":"Table_productName__1HMVY"};